var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _c('div', {
    staticClass: "page"
  }, [_vm._m(0), _c('div', {
    staticClass: "footer-action-bar"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": "回官方帳號",
      "type": "OA"
    }
  })], 1)])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon-check-circle.svg")
    }
  }), _c('div', {
    staticClass: "mt-3 font-weight-bold"
  }, [_vm._v("此預約不存在")])]);
}]

export { render, staticRenderFns }